// Contract configuration
// Contract deployed to Polygon Amoy testnet on 2026-03-22
// Includes dispute resolution features (US1, US2, US4)
export const CONTRACT_ADDRESS = process.env.VITE_ESCROW_CONTRACT_ADDRESS || "0x17314620dbcd30cF4243EC6B791c8Bdd514bca20";

// Polygon Amoy Testnet configuration (Mumbai replacement)
export const POLYGON_AMOY = {
  chainId: "0x13882", // 80002 in hex
  chainName: "Polygon Amoy",
  nativeCurrency: {
    name: "MATIC",
    symbol: "MATIC",
    decimals: 18,
  },
  rpcUrls: ["https://polygon-amoy-bor-rpc.publicnode.com"],
  blockExplorerUrls: ["https://amoy.polygonscan.com"],
};

// Import ABI from Hardhat artifact
import ESCROW_ABI_ARTIFACT from "./escrow-abi.json";
// Extract the ABI array from the Hardhat artifact
export const ESCROW_ABI = (ESCROW_ABI_ARTIFACT as any).abi as any[];

